exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 650px) {\n  .respon1 {\n    display: none !important; } }\n\n@media only screen and (min-width: 650px) {\n  .respon2 {\n    display: none !important; } }\n\n.underline {\n  text-align: right;\n  border-bottom: 1px #a2a4a9 solid;\n  padding: 20px; }\n\n.docTypeFb {\n  margin-left: 55px; }\n\n.docTypeArticle {\n  margin-left: 0px; }\n\n.sk-wave .sk-rect {\n  background-color: white; }\n\n.modal-body {\n  padding: 0px !important; }\n\n.mb-20 {\n  height: 400px;\n  margin-bottom: 20px; }\n\n.dsb-item {\n  height: 400px;\n  margin-bottom: 65px; }\n\n.mb-40 {\n  height: 400px;\n  margin-bottom: 40px; }\n\n.project-name {\n  color: #2b9bdc;\n  text-transform: uppercase;\n  font-size: 30px;\n  font-weight: 1000;\n  font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/line-chart/line-chart.component.scss
// module id = ../../../../../src/app/_custom/line-chart/line-chart.component.scss
// module chunks = main